module.exports = __webpack_public_path__ + "static/img/AAAqiyexinyongpingji.f8737a30.jpg";